import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

const ErrorMsg = ({ children, className }) => (
  <div className={classnames('c-heading u-co-red epsilon u-type--bold', className)}>
    {children}
  </div>
);
ErrorMsg.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
ErrorMsg.defaultProps = {
  className: '',
};

export default ErrorMsg;



// WEBPACK FOOTER //
// ./src/app/components/ErrorMsg.jsx